import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CostaAppService {
  confirm() {
    window.location.href = 'mycosta://reloadAgenda';
  }

  close() {
    window.location.href = 'mycosta://goToRestaurantsList';
  }
}
